import {useMotionValueEvent, useScroll} from 'framer-motion';
import {useState} from 'react';

const useIsElStickied = (
    elRef: React.RefObject<HTMLDivElement | null>,
    offset?: number,
) => {
    const [isStickied, setIsStickied] = useState(false);
    const stickyOffset = offset || 0;

    const {scrollYProgress} = useScroll({
        target: elRef,
        offset: [`start end`, `start ${stickyOffset}px`],
    });

    useMotionValueEvent(scrollYProgress, 'change', latest => {
        setIsStickied(latest === 1);
    });

    return isStickied;
};

export default useIsElStickied;
